import React from 'react';
import Helmet from 'react-helmet';
import HtmlParser from 'html-react-parser';
import ReactPlayer from 'react-player';
import SEO from '../../components/SEO';
import Layout from '../../layouts/index';
import { DemoFormLong } from '../../components/DemoFormLong.jsx';
import { DemoFormShort } from '../../components/DemoFormShort.jsx';
import JoinHappyCustomers from '../../components/JoinHappyCustomers';
import MultimedialPanel from '../../components/MultimedialPanel';

const Home = (props) => {

    const location = props.location;

    return (
        <Layout bodyClass="page-integrations performance" ontouchstart>
            <SEO title="Performance Management | ChartHop | The Org Management Platform" />
            <Helmet>
                <meta
                    name="description"
                    content="Leverage performance data to make more thoughtful, unbiased, data-informed decision about compensation, promotions, and hiring - all in one place."
                />
                <meta property="og:url" content={`https://www.charthop.com${location.pathname}`} />
                <meta property="og:title" content="Performance Management | ChartHop | The Org Management Platform" />
                <meta property="og:description" content="Leverage performance data to make more thoughtful, unbiased, data-informed decision about compensation, promotions, and hiring - all in one place." />
                <meta property="og:image" content={`https://www.charthop.com/home/meta-performance.png`} />
                <meta property="og:type" content="website" />
                <meta property="og:locale" content="en_US" />
        		<meta property="og:site_name" content="ChartHop" />
                {/* Twitter Card tags */}
                <meta name="twitter:title" content="Performance Management | ChartHop | The Org Management Platform" />
                <meta name="twitter:description" content="Leverage performance data to make more thoughtful, unbiased, data-informed decision about compensation, promotions, and hiring - all in one place." />
                <meta name="twitter:image" content={`https://www.charthop.com/home/meta-performance.png`} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@charthop" />
                <meta name="twitter:creator" content="@charthop" />
            </Helmet>            

            {/* HERO CONTENT */}
            <section className="intro container">
                <div className="row py-5 align-items-center">
                    <div className="col-md-6 p-xs-2 mb-3 mb-md-0 pr-md-2 pr-lg-4">
                        <h1>Performance reviews that impact company performance.</h1>
                        <p className="header-p pb-1 pt-1">Finally, leverage performance data to inform your greater strategy.</p>
                        <div className="splitText"><DemoFormShort source={"product-performance-demo-header"} /></div>                     
                    </div>
                    <div className="reactPlayerContainer col-md-6 order-md-1 padding-top-video-one">                        
                        <img className="imageBoxShaddow fullSegmentImage mx-auto" src={'/product/performance/performance-by-groups-update.gif'} alt="Performance Review Questions" />
					</div>
                </div>
            </section>

            <section className="customer testimonial-container backgroundGradientContainer pt-8 pb-5">
                <JoinHappyCustomers title={HtmlParser('Join our <span class="blue-text">hoppy</span> customers')}></JoinHappyCustomers>
            </section>

            <div className="sectionSpacing mx-0 mt-0">
                <h4 className="listTitle text-xs-left mt-0 text-sm-center">Everything you need to manage your team</h4>
                <div className="pgc1">
                    <div className="pgc2">
                        <div className="pgc3">
                            <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                            <p>Formal reviews</p>
                        </div>
                    </div>
                    <div className="pgc2">
                        <div className="pgc3">
                            <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                            <p>360 reviews</p>
                        </div>
                    </div>
                    <div className="pgc2">
                        <div className="pgc3">
                            <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                            <p>Informal feedback</p>
                        </div>
                    </div>
                    <div className="pgc2">
                        <div className="pgc3">
                            <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                            <p>Engagement surveys</p>
                        </div>
                    </div>
                    <div className="pgc2">
                        <div className="pgc3">
                            <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                            <p>KPI definition</p>
                        </div>
                    </div>
                    <div className="pgc2">
                        <div className="pgc3">
                            <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                            <p>1:1 tracking</p>
                        </div>
                    </div>
                </div>
            </div>

            <section className="sectionSpacing flex-centeredColumn backgroundGradientContainer" >
                <h2 className="text-center mt-0 sectionSpacing-Margin">The flexibility you’ve been looking for<br></br> in the platform that makes it useful.</h2> 
                <div className="flex-centeredColumn contentBlock">
					<div className="svg-info ">
                        <div className="svg-info-card-3col">
                            <img src={'/product/performance/customize.svg'} alt="Customize" />
                            <h3>Customize everything</h3>
                            <p className="py-1">No more one size fits all.</p>
                            <p>Build distinct processes, questions, approval flows and access controls by department, location, manager, role & more.</p>
                        </div>                        
                        <div className="svg-info-card-3col">
                            <img src={'/product/performance/results.svg'} alt="Results" />
							<h3>See results immediately</h3>
							<p className="py-1">Access and analyze the data as soon as you start collecting it.</p>
                            <p>Easily send individual or mass reminders using the <b>Slack</b> integration.</p>
						</div>
                        <div className="svg-info-card-3col">
                            <img src={'/product/performance/control.svg'} alt="Control" />
							<h3>Control data access</h3>
							<p className="py-1">Ensure data is seen by those who need it and not by those who don’t.</p>
                            <p>With over 14 access levels, anything is possible.</p>
						</div>
                    </div>
				</div>
            </section>

		
			<section className="sectionSpacing">
				<div className="contentBlock">
                    <MultimedialPanel 
                        multimediaPosition="left"
                        title="Build to meet your needs"
                        link="/product/performance/perf-review-questions.png"
                        type="image"
                        paddingClass="padding-top-video-two"
                        content={
                            <React.Fragment>
                                <p>Set up the performance management processes that works for you.</p>
                                <p>Run everything from annual assessment and quarterly reviews to monthly check-ins and weekly 1:1s.</p>
                            </React.Fragment>
                        }
                    />					
				</div>
			</section>

            <section className="sectionSpacing backgroundGradientContainer">
				<div className="contentBlock">
                    <MultimedialPanel 
                        multimediaPosition="right"
                        title="Make fair and equitable decisions"
                        link="/product/performance/make-fair.png"
                        type="image"
                        paddingClass="padding-top-video-two"
                        content={
                            <React.Fragment>
                                <p>Layer in data from other systems to effectively calibrate data and uncover hidden biases. </p>  
                                <p>Put everything in context to see the full picture and  make more thoughtful, unbiased, data-informed decision about compensation, promotions, and hiring - all in one place.</p>
                            </React.Fragment>
                        }
                    />					
				</div>
			</section>

            <section className="sectionSpacing" >
				<div className="contentBlock">
                    <MultimedialPanel 
                        multimediaPosition="left"
                        title="Track trends"
                        link="/product/performance/reports-one-on-one-ethnicity.gif"
                        type="image"
                        paddingClass="padding-top-video-two"
                        content={
                            <React.Fragment>
                                <p>Understand point in time and longitudinal trends using pre-made and custom reports.</p>  
                                <p>Easily upload historic data from any source.</p>
                            </React.Fragment>
                        }
                    />					
				</div>
			</section>

            {/* LONG FORM */}
            <section name="request-demo " id="request-demo" className="request-demo pt-3 pb-4 pt-md-8 pb-md-8">
				<DemoFormLong source={"product-performance-demo-bottom"} headertext={HtmlParser('<div class="contactTestimonial pr-md-1"><p class=" mb-3 contact-testimonial">"ChartHop helped us replace our mundane, outdated processes - there is nothing else like it. </br><br/> I can not imagine what we would do without ChartHop.”</p><div class="authorTag"><img src="/home/quotes/quote_DavidDankenbrink@2x.jpg" class="testimonialAuthor" alt="David Dankenbrink" /><div><p class="contactAuthor"><strong>David Dankenbrink</strong> <br>Vice President, Human Resources @ Remy Cointreau</p></div></div>')}/>
			</section>
        </Layout>
    );
};


export default Home;
